// Inline Progress Indicator/Spinner Buttons
// Has a dependency on the Ladda buttons js and CSS in vendor folders

bq.loadingButton = function(element, options) {
  this.options = options;
  this.$element = $(element);
};

bq.loadingButton.DEFAULTS = {};

bq.loadingButton.prototype = {
  init: function() {

    var self = this;

    bq.debug.log("Loading Button : init()", this.$element);

    this.laddaRef = Ladda.create(self.$element[0]);
    this.$element.on('bq.loadingbutton.start', function(){
      self.laddaRef.start();
    });

    this.$element.on('bq.loadingbutton.success', function(){
      self.$element.find('.ladda-spinner').hide();
      self.$element.removeAttr('disabled');
      self.$element.append('<span class="loading-button-success"><span class="fa fa-check"></span></span>').addClass('onepage-ladda-btn-success');
      setTimeout(function(){
        self.$element.attr('disabled', 'disabled');
      }, 1000);
    });

    this.$element.on('bq.loadingbutton.error', function(){
      self.$element.find('.ladda-spinner').hide();
      self.$element.removeAttr('disabled');
      self.$element.append('<span class="loading-button-error"><span class="fa fa-exclamation"></span></span>').addClass('onepage-ladda-btn-error');
      setTimeout(function(){
        self.$element.attr('disabled', 'disabled');
      }, 1000);
    });

    this.$element.on('bq.loadingbutton.stop', function(){
      self.$element.find('.loading-button-success, .loading-button-error').remove();
      self.$element.removeClass('onepage-ladda-btn-success onepage-ladda-btn-error');
      self.$element.attr('disabled', 'disabled');
      self.laddaRef.stop();
      self.$element.find('.ladda-spinner').show();
    });

  }
};

// Loading Button PLUGIN DEFINITION
// =======================

var loadingButtonold = $.fn.loadingButton;

$.fn.loadingButton = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.loadingButton');
    var options = $.extend({}, bq.loadingButton.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.loadingButton', (data = new bq.loadingButton(this, options))); }
    data.init();
  });
};

$.fn.loadingButton.Constructor = bq.loadingButton;

// Loading Button NO CONFLICT
// =================

$.fn.loadingButton.noConflict = function () {
  $.fn.loadingButton = loadingButtonold;
  return this;
};

// Loading Button DATA-API
// ==============
bq.loadingButtonInit = function () {
  $('[data-bq="loading-button"]').each(function () {
    var $el = $(this);
    if($el.data('bq.loadingButton')) { return; }
    $el.loadingButton($el.data());
  });
};

bq.init.push(bq.loadingButtonInit);
